import { render, staticRenderFns } from "./EstadoVenta.vue?vue&type=template&id=125926ae"
import script from "./EstadoVenta.vue?vue&type=script&lang=js"
export * from "./EstadoVenta.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports